<ISelectMenu [value]="selectedCurrencyOption()" (valueChange)="changeCurrency($event)" [(searchQuery)]="searchQuery">
  <ISelectTrigger>
    <ISelectValue>
      <div *iSelectValue="let value" class="flex items-center gap-2">
        <div class="text-muted-foreground truncate">
          {{ value?.label }}
        </div>
        <div class="hidden xl:inline">{{ value?.value }}</div>
      </div>
    </ISelectValue>
  </ISelectTrigger>
  <ISelectContent>
    @for (currency of filteredCurrencies(); track currency.value) {
      <ISelectOption [value]="currency">
        <div class="flex items-center gap-2">
          <div class="text-muted-foreground truncate">
            {{ currency.label }}
          </div>
          <div class="hidden xl:inline">{{ currency.value }}</div>
        </div>
      </ISelectOption>
    }
  </ISelectContent>
</ISelectMenu>
